/* global bocAmchart, AmCharts */

/**
 * Adds graph to a chart object
 *
 * @param {object} chart object
 * @param {string|string[]} series name
 * @param {string} label to use in chart
 * @param {string} defaultType type to use if type is not set in shortcode
 * @param {int} id for this graph
 * @returns {void}
 */
bocAmchart.addGraph = function (chart, series, label, defaultType, id) {

    var i;
    if (typeof chart.graphs !== 'object') {
        if (bocAmchart.debug(chart)) {
            // eslint-disable-next-line no-console
            console.log(
                chart.bocSettings.id,
                "Resetting graphs (graphs array is not defined?):",
                bocAmchart.debugClone(chart.graphs)
            );
        }
        chart.graphs = [];
    }

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Existing graphs:",
            bocAmchart.debugClone(chart.graphs)
        );
    }

    if (typeof id !== 'undefined' && typeof chart.graphs[id] === 'undefined') {
        i = id;
    } else {
        for (var index = 0; index < 100; index++) {
            if (typeof chart.graphs[index] === 'undefined') {
                i = index;
                break;
            }
        }
    }

    var valueSuffix = '';

    if (chart.bocSettings.args.hasOwnProperty('chartunit')) {
        valueSuffix = chart.bocSettings.args.chartunit;
    } else {
        if (typeof bocAmchart.vars === 'object'
            && typeof bocAmchart.vars[chart.bocSettings.id] === 'object'
            && typeof bocAmchart.vars[chart.bocSettings.id]['valueSuffix'] === 'string') {
            valueSuffix = bocAmchart.vars[chart.bocSettings.id]['valueSuffix'];
        }
    }

    var thisLabel = label;
    var thisType = defaultType ? defaultType : 'line';
    var thisAxis = '';
    var thisColor = '';
    var thisPattern = '';
    var thisHidden = false;
    var thisXField = 'x';
    var thisColumnWidth = 0.8;
    var thisBalloonText = '';

    if (chart.bocSettings.args.hasOwnProperty('series' + i + 'label')) {
        thisLabel = chart.bocSettings.args['series' + i + 'label'];
    }
    if (chart.bocSettings.args.hasOwnProperty('series' + i + 'type')) {
        thisType = chart.bocSettings.args['series' + i + 'type'];
    }
    if (chart.bocSettings.args.hasOwnProperty('series' + i + 'axis')) {
        thisAxis = chart.bocSettings.args['series' + i + 'axis'];
    }
    if (chart.bocSettings.args.hasOwnProperty('series' + i + 'color')) {
        thisColor = chart.bocSettings.args['series' + i + 'color'];
    }
    if (chart.bocSettings.args.hasOwnProperty('series' + i + 'pattern')) {
        thisPattern = chart.bocSettings.args['series' + i + 'pattern'];
    }
    if (chart.bocSettings.args.hasOwnProperty('series' + i + 'hidden')) {
        thisHidden = chart.bocSettings.args['series' + i + 'hidden'];
    }
    if (chart.bocSettings.args.hasOwnProperty('series' + i + 'xfield')) {
        thisXField = chart.bocSettings.args['series' + i + 'xfield'];
    }
    if (chart.bocSettings.args.hasOwnProperty('series' + i + 'columnwidth')) {
        thisColumnWidth = chart.bocSettings.args['series' + i + 'columnwidth'];
    }
    if (chart.bocSettings.args.hasOwnProperty('series' + i + 'balloontext')) {
        thisBalloonText = chart.bocSettings.args['series' + i + 'balloontext'];
    }

    var graph = {};

    if (typeof series === 'object') {
        graph = {
            "id": "g" + i,
            "title": thisLabel,
            "openField": series[0],
            "closeField": series[1],
            "balloonText": "<span style='font-size: 14px;'>"
                + "[[" + series[0] + "]] " + valueSuffix + " : " + series[0] + "<br> "
                + "[[" + series[1] + "]] " + valueSuffix + " : " + series[1]
                + "</span>"
        };
        if (series.length === 4) {
            graph.highField = series[2];
            graph.lowField = series[3];
            graph.lineThickness = 2;
        }

    } else {
        if (chart.type === 'xy') {
            graph = {
                "id": "g" + i,
                "title": thisLabel,
                "xField": thisXField,
                "yField": series,
                "balloonText": "<span style='font-size: 14px;'>([[" + thisXField + "]], [[" + series + "]])"
                    + " - " + thisLabel + "</span>"
            };
        } else {
            graph = {
                "id": "g" + i,
                "title": thisLabel,
                "valueField": series,
                "balloonText": "<span style='font-size: 14px;'>[[value]]"
                    + valueSuffix + " [[" + series + "_R]]- " + thisLabel + "</span>"
            };
        }
    }

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Initializing graph:",
            bocAmchart.debugClone(graph),
            "Index: ",
            i
        );
    }

    if (thisBalloonText) {
        graph.balloonText = thisBalloonText.split("{{").join("[[").split("}}").join("]]");
        if (bocAmchart.debug(chart)) {
            // eslint-disable-next-line no-console
            console.log(
                chart.bocSettings.id,
                "Setting custom balloon:",
                bocAmchart.debugClone(graph.balloonText),
                "Index: ",
                i
            );
        }
    }

    if (thisHidden === 'true') {
        graph.hidden = true;
    }

    if (thisColor) {
        if (thisColor.slice(0, 1) === '#') {
            graph.lineColor = thisColor;
        } else {
            if (toString(parseInt(thisColor)) === toString(thisColor)) {
                graph.lineColor = AmCharts.themes[chart.bocSettings.theme].AmCoordinateChart.colors[thisColor];
            }
        }
    }
    if (bocAmchart.debug(chart)) {
        if (graph.lineColor) {
            // eslint-disable-next-line no-console
            console.log(
                chart.bocSettings.id,
                "Set the custom color for graph:",
                bocAmchart.debugClone(graph)
            );
        }
    }

    bocAmchart.setGraphType(chart, graph, thisType);

    if (thisPattern && (thisType === "fill" || thisType === "column" || thisType === "candlestick")) {
        if (thisColor !== '') {
            graph.pattern = bocAmchart.getPattern(thisColor, thisPattern, 1);
        } else {
            graph.pattern = bocAmchart.getPattern(i, thisPattern, 1);
        }
    }

    if (thisType === "column" || thisType === "candlestick") {
        graph.columnWidth = thisColumnWidth;
    }

    if (thisType === 'line' || thisType === 'marker') {
        bocAmchart.initChartVars(chart);
        bocAmchart.vars[chart.bocSettings.id].dashed = bocAmchart.vars[chart.bocSettings.id].dashed || {};
        var dashed = {};

        if (chart.bocSettings.args.hasOwnProperty('series' + i + 'dashstart')) {
            graph.dashLengthField = series + "_dashLength";
            dashed["start"] = chart.bocSettings.args['series' + i + 'dashstart'];
            if (chart.bocSettings.args.hasOwnProperty('series' + i + 'dashend')) {
                dashed["end"] = chart.bocSettings.args['series' + i + 'dashend'];
            }
            if (chart.bocSettings.args.hasOwnProperty('series' + i + 'dashlength')) {
                dashed["length"] = chart.bocSettings.args['series' + i + 'dashlength'];
            }
            bocAmchart.vars[chart.bocSettings.id].dashed[series] = dashed;
            graph.dashLengthSwitched = true;
        } else {
            if (chart.bocSettings.args.hasOwnProperty('series' + i + 'dashlength')) {
                graph.dashLength = chart.bocSettings.args['series' + i + 'dashlength'];
            }
        }
    }

    if (thisAxis) {
        graph.valueAxis = thisAxis;
    }
    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Before push graphs:",
            bocAmchart.debugClone(chart.graphs),
            "Index: " + i
        );
    }

    chart.graphs[i] = graph;

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Pushed graph to an array:",
            "Index: " + i,
            bocAmchart.debugClone(chart.graphs)
        );
    }
};

/**
 * @param {string|int} colorIndex Either index of the color, or the string of the hex color
 * @param {string} pattern - one of the predefined string ids
 * @param {float} opacity of the pattern
 * @returns {void}
 */
bocAmchart.getPattern = function (colorIndex, pattern, opacity) {
    // default to gray color
    var color = "#888888";
    if (isNaN(colorIndex)) {
        color = colorIndex;
    } else {
        if (typeof AmCharts.themes[bocAmchart.theme].AmCoordinateChart.colors !== 'undefined') {
            color = AmCharts.themes[bocAmchart.theme].AmCoordinateChart.colors[colorIndex];
        }
    }

    if (typeof pattern === 'undefined') {
        pattern = 'diagonal';
    }

    if (typeof opacity === 'undefined') {
        opacity = 1;
    }

    var encodedPatterns = {
        "diagonal": {
            "url": "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23" + color.substring(1) + "' fill-opacity='" + opacity + "' fill-rule='evenodd'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/svg%3E",
            "width": 8,
            "height": 8
        },
        "stripes": {
            "url": "data:image/svg+xml,%3Csvg width='8' height='1' viewBox='0 0 8 1' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h4v1H0z' fill='%23" + color.substring(1) + "' fill-opacity='" + opacity + "' fill-rule='evenodd'/%3E%3C/svg%3E",
            "width": 8,
            "height": 1
        },
        "checkers": {
            "url": "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3E%3Cg fill='%23" + color.substring(1) + "' fill-opacity='" + opacity + "'%3E%3Cpath fill-rule='evenodd' d='M0 0h4v4H0V0zm4 4h4v4H4V4z'/%3E%3C/g%3E%3C/svg%3E",
            "width": 8,
            "height": 8
        }
    };

    return encodedPatterns[pattern];

};

/**
 * Function to set defaults per type of graph
 * @param {AmCharts} chart Chart objecty
 * @param {object} graph Graph object
 * @param {string} thisType graph type
 * @returns {void}
 */
bocAmchart.setGraphType = function (chart, graph, thisType) {

    var defaults = {
        "column": {
            "type": "column",
            "fillAlphas": 0.8,
            "lineAlpha": 0,
            "lineThickness": 0,
            "bullet": "none"
        },
        "fill": {
            "type": "line",
            "fillAlphas": 0.5,
            "lineAlpha": 0.5,
            "lineThickness": 1,
            "bullet": "none"
        },
        "step": {
            "type": "step",
            "fillAlphas": 0,
            "lineAlpha": 0.9,
            "lineThickness": 2,
            "bullet": "none"
        },
        "line": {
            "type": "line",
            "fillAlphas": 0,
            "lineAlpha": 0.9,
            "lineThickness": 2,
            "bullet": "none"
        },
        "marker": {
            "type": "line",
            "fillAlphas": 0,
            "lineAlpha": 0.9,
            "lineThickness": 2,
            "useLineColorForBulletBorder": true,
            "bulletSize": 8,
            "bulletBorderAlpha": 0,
            "bulletBorderThickness": 0
        },
        "scatter": {
            "type": "line",
            "fillAlphas": 0,
            "lineAlpha": 0,
            "lineThickness": 0,
            "useLineColorForBulletBorder": true,
            "bulletSize": 8,
            "bulletBorderAlpha": 0,
            "bulletBorderThickness": 0
        },
        "bullet": {
            "type": "line",
            "fillAlphas": 0,
            "lineAlpha": 0,
            "lineThickness": 0,
            "useLineColorForBulletBorder": false,
            "bulletBorderColor": AmCharts.themes[chart.bocSettings.theme].AmCoordinateChart.colors[51],
            "bulletSize": 16,
            "bulletBorderAlpha": 1,
            "bulletBorderThickness": 2
        },
        "candlestick": {
            "type": "candlestick",
            "fillAlphas": 0.8,
            "bullet": "none"
        }
    };

    var shapes = [
        'round',
        'triangleUp',
        'diamond',
        'square',
        "triangleDown",
        "triangleLeft",
        "triangleRight"
    ];

    var index;

    // Getting the per type overrides from the chart JS settings
    if (typeof chart.bocSettings.graphDefaults === 'object' && chart.bocSettings.graphDefaults.hasOwnProperty(thisType)) {
        if (!defaults.hasOwnProperty(thisType)) {
            defaults[thisType] = {};
        }
        for (var property in chart.bocSettings.graphDefaults[thisType]) {
            if (chart.bocSettings.graphDefaults[thisType].hasOwnProperty(property)) {
                defaults[thisType][property] = chart.bocSettings.graphDefaults[thisType][property];
            }
        }
    }

    // Check if some defaults need to be overridden based on type
    if (defaults.hasOwnProperty(thisType)) {
        for (var prop in defaults[thisType]) {
            if (defaults[thisType].hasOwnProperty(prop)) {
                graph[prop] = defaults[thisType][prop];
            }
        }
    }

    if (thisType === "bullet") {
        bocAmchart.initChartVars(chart);
        index = bocAmchart.vars[chart.bocSettings.id].bulletIndex | 0;
        if (index === shapes.length) {
            index = 0;
        }
        graph.bullet = shapes[index];
        bocAmchart.vars[chart.bocSettings.id].bulletIndex = ++index;

        if (chart.hasOwnProperty('chartCursor') && chart.chartCursor !== null) {
            chart.chartCursor.graphBulletSize = "1";
        }
    }

    if (thisType === "scatter" || thisType === "marker") {
        bocAmchart.initChartVars(chart);
        index = bocAmchart.vars[chart.bocSettings.id].bulletIndex | 0;
        if (index === shapes.length) {
            index = 0;
        }
        graph.bullet = shapes[index];
        bocAmchart.vars[chart.bocSettings.id].bulletIndex = ++index;
    }
};
